<template>
  <div>
    <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
      <div class="d-flex justify-center align-center pa-5 h1 display-4">
        <div>{{$t('drSignaturePad.signature')}}</div>
      </div>
      <div class="d-flex justify-space-between">
        <v-btn>{{$t('drSignaturePad.clear')}}</v-btn>
        <v-btn>{{$t('drSignaturePad.save')}}</v-btn>
      </div>
    </dr-wrapper>
    <dr-signature-pad-component
      v-else-if="isVisible"
      v-bind="$props"
      @callDataSourceAction="$emit('callDataSourceAction', $event)"
    ></dr-signature-pad-component>
  </div>
</template>

<script>
import uk from '../../langs/signaturePad/uk.json'
import ru from '../../langs/signaturePad/ru.json'
import en from '../../langs/signaturePad/en.json'
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import drSignaturePadComponent from './dr-signature-pad-component'

export default {
  mixins: [mixin, inputMixin],
  components: {
    drSignaturePadComponent
  },
  i18n: {
    messages: {
      uk,
      en,
      ru
    }
  }
}
</script>
